export const TIME_RANGE_LIST = [
  {
    label: "00:00",
    key: "00:00:00",
    value: "00:00:00",
  },
  {
    label: "00:30",
    key: "00:30:00",
    value: "00:30:00",
  },
  {
    label: "01:00",
    key: "01:00:00",
    value: "01:00:00",
  },
  {
    label: "01:30",
    key: "01:30:00",
    value: "01:30:00",
  },
  {
    label: "02:00",
    key: "02:00:00",
    value: "02:00:00",
  },
  {
    label: "02:30",
    key: "02:30:00",
    value: "02:30:00",
  },
  {
    label: "03:00",
    key: "03:00:00",
    value: "03:00:00",
  },
  {
    label: "03:30",
    key: "03:30:00",
    value: "03:30:00",
  },
  {
    label: "04:00",
    key: "04:00:00",
    value: "04:00:00",
  },
  {
    label: "04:30",
    key: "04:30:00",
    value: "04:30:00",
  },
  {
    label: "05:00",
    key: "05:00:00",
    value: "05:00:00",
  },
  {
    label: "05:30",
    key: "05:30:00",
    value: "05:30:00",
  },
  {
    label: "06:00",
    key: "06:00:00",
    value: "06:00:00",
  },
  {
    label: "06:30",
    key: "06:30:00",
    value: "06:30:00",
  },
  {
    label: "07:00",
    key: "07:00:00",
    value: "07:00:00",
  },
  {
    label: "07:30",
    key: "07:30:00",
    value: "07:30:00",
  },
  {
    label: "08:00",
    key: "08:00:00",
    value: "08:00:00",
  },
  {
    label: "08:30",
    key: "08:30:00",
    value: "08:30:00",
  },
  {
    label: "09:00",
    key: "09:00:00",
    value: "09:00:00",
  },
  {
    label: "09:30",
    key: "09:30:00",
    value: "09:30:00",
  },
  {
    label: "10:00",
    key: "10:00:00",
    value: "10:00:00",
  },
  {
    label: "10:30",
    key: "10:30:00",
    value: "10:30:00",
  },
  {
    label: "11:00",
    key: "11:00:00",
    value: "11:00:00",
  },
  {
    label: "11:30",
    key: "11:30:00",
    value: "11:30:00",
  },
  {
    label: "12:00",
    key: "12:00:00",
    value: "12:00:00",
  },
  {
    label: "12:30",
    key: "12:30:00",
    value: "12:30:00",
  },
  {
    label: "13:00",
    key: "13:00:00",
    value: "13:00:00",
  },
  {
    label: "13:30",
    key: "13:30:00",
    value: "13:30:00",
  },
  {
    label: "14:00",
    key: "14:00:00",
    value: "14:00:00",
  },
  {
    label: "14:30",
    key: "14:30:00",
    value: "14:30:00",
  },
  {
    label: "15:00",
    key: "15:00:00",
    value: "15:00:00",
  },
  {
    label: "15:30",
    key: "15:30:00",
    value: "15:30:00",
  },
  {
    label: "16:00",
    key: "16:00:00",
    value: "16:00:00",
  },
  {
    label: "16:30",
    key: "16:30:00",
    value: "16:30:00",
  },
  {
    label: "17:00",
    key: "17:00:00",
    value: "17:00:00",
  },
  {
    label: "17:30",
    key: "17:30:00",
    value: "17:30:00",
  },
  {
    label: "18:00",
    key: "18:00:00",
    value: "18:00:00",
  },
  {
    label: "18:30",
    key: "18:30:00",
    value: "18:30:00",
  },
  {
    label: "19:00",
    key: "19:00:00",
    value: "19:00:00",
  },
  {
    label: "19:30",
    key: "19:30:00",
    value: "19:30:00",
  },
  {
    label: "20:00",
    key: "20:00:00",
    value: "20:00:00",
  },
  {
    label: "20:30",
    key: "20:30:00",
    value: "20:30:00",
  },
  {
    label: "21:00",
    key: "21:00:00",
    value: "21:00:00",
  },
  {
    label: "21:30",
    key: "21:30:00",
    value: "21:30:00",
  },
  {
    label: "22:00",
    key: "22:00:00",
    value: "22:00:00",
  },
  {
    label: "22:30",
    key: "22:30:00",
    value: "22:30:00",
  },
  {
    label: "23:00",
    key: "23:00:00",
    value: "23:00:00",
  },
  {
    label: "23:30",
    key: "23:30:00",
    value: "23:30:00",
  },
];
